import axios from "axios";
import { store } from "../redux/store";
import { logout } from "../redux/features/auth/authSlice";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axiosClient = axios.create({
  baseURL: API_BASE_URL + "/api",
  timeout: 30000, // Thời gian chờ tối đa cho mỗi request (30 giây)
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor cho Request: Thêm token vào header nếu có
axiosClient.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.token; // Lấy token từ Redux store
    //const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Thêm token vào header Authorization
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Interceptor cho Response: Xử lý lỗi tập trung
axiosClient.interceptors.response.use(
  (response) => {
    if (response.config.responseType === "blob") {
      return response;
    }
    return response.data;
  },
  (error) => {
    const { response } = error;
    if (response) {
      const errorMessage = response.data.message || "Có lỗi xảy ra từ máy chủ.";
      console.error("API Error:", errorMessage, response.status);

      // Ví dụ: Xử lý lỗi 401 (Unauthorized) - đẩy người dùng về trang đăng nhập
      if (response.status === 401) {
        store.dispatch(logout());
        window.location.href = "/login"; // Chuyển hướng về trang đăng nhập
        return Promise.reject(errorMessage);
      }
      //return Promise.reject(errorMessage); // Trả về message lỗi để component có thể hiển thị
      return response.data;
    } else if (error.request) {
      // Request được gửi nhưng không nhận được response (ví dụ: mất mạng, server down)
      console.error("Network Error:", error.message);
      return Promise.reject(
        "Chưa nhận được phản hồi từ máy chủ. Vui lòng thử lại.",
      );
    } else {
      // Lỗi khác khi thiết lập request
      console.error("Error:", error.message);
      return Promise.reject("Có lỗi xảy ra. Vui lòng thử lại.");
    }
  },
);

export default axiosClient;
